import importer from 'common/importer'

const login = importer('Sagas/AuthCustom/login/main')
const loginSuccess = importer('Sagas/AuthCustom/login/success')
const loginFailure = importer('Sagas/AuthCustom/login/failure')

const loginAuth = importer('Sagas/AuthCustom/loginAuth/main')
const loginAuthSuccess = importer('Sagas/AuthCustom/loginAuth/success')
const loginAuthFailure = importer('Sagas/AuthCustom/loginAuth/failure')

const loginTokenExchange = importer('Sagas/AuthCustom/loginTokenExchange/main')
const loginTokenExchangeSuccess = importer('Sagas/AuthCustom/loginTokenExchange/success')
const loginTokenExchangeFailure = importer('Sagas/AuthCustom/loginTokenExchange/failure')

const loginHeroku = importer('Sagas/AuthCustom/loginHeroku/main')
const loginHerokuSuccess = importer('Sagas/AuthCustom/loginHeroku/success')
const loginHerokuFailure = importer('Sagas/AuthCustom/loginHeroku/failure')

const logout = importer('Sagas/AuthCustom/logout/main')
const logoutSuccess = importer('Sagas/AuthCustom/logout/success')
const logoutFailure = importer('Sagas/AuthCustom/logout/failure')

const register = importer('Sagas/AuthCustom/register/main')
const registerSuccess = importer('Sagas/AuthCustom/register/success')
const registerFailure = importer('Sagas/AuthCustom/register/failure')

const getSession = importer('Sagas/AuthCustom/getSession/main')
const getSessionSuccess = importer('Sagas/AuthCustom/getSession/success')
const getSessionFailure = importer('Sagas/AuthCustom/getSession/failure')

const getSessionUser = importer('Sagas/AuthCustom/getSessionUser/main')
const getSessionUserSuccess = importer('Sagas/AuthCustom/getSessionUser/success')
const getSessionUserFailure = importer('Sagas/AuthCustom/getSessionUser/failure')

const changePassword = importer('Sagas/AuthCustom/changePassword/main')
const changePasswordSuccess = importer('Sagas/AuthCustom/changePassword/success')
const changePasswordFailure = importer('Sagas/AuthCustom/changePassword/failure')

const changeRecoveryQuestion = importer('Sagas/AuthCustom/changeRecoveryQuestion/main')
const changeRecoveryQuestionSuccess = importer('Sagas/AuthCustom/changeRecoveryQuestion/success')
const changeRecoveryQuestionFailure = importer('Sagas/AuthCustom/changeRecoveryQuestion/failure')

const forgotPassword = importer('Sagas/AuthCustom/forgotPassword/main')
const forgotPasswordSuccess = importer('Sagas/AuthCustom/forgotPassword/success')
const forgotPasswordFailure = importer('Sagas/AuthCustom/forgotPassword/failure')

const sessionRefresh = importer('Sagas/AuthCustom/sessionRefresh/main')
const sessionRefreshSuccess = importer('Sagas/AuthCustom/sessionRefresh/success')
const sessionRefreshFailure = importer('Sagas/AuthCustom/sessionRefresh/failure')

export default {
  login,
  loginSuccess,
  loginFailure,

  loginAuth,
  loginAuthSuccess,
  loginAuthFailure,

  loginHeroku,
  loginHerokuSuccess,
  loginHerokuFailure,

  loginTokenExchange,
  loginTokenExchangeSuccess,
  loginTokenExchangeFailure,

  logout,
  logoutSuccess,
  logoutFailure,

  register,
  registerSuccess,
  registerFailure,

  getSession,
  getSessionSuccess,
  getSessionFailure,

  getSessionUser,
  getSessionUserSuccess,
  getSessionUserFailure,

  changePassword,
  changePasswordSuccess,
  changePasswordFailure,

  changeRecoveryQuestion,
  changeRecoveryQuestionSuccess,
  changeRecoveryQuestionFailure,

  forgotPassword,
  forgotPasswordSuccess,
  forgotPasswordFailure,

  sessionRefresh,
  sessionRefreshSuccess,
  sessionRefreshFailure
}
